import { NotificationContext } from 'Components/Notification/context'
import React, { useContext } from 'react'
import { CopyToClipboard as RawCopyToClipboard } from 'react-copy-to-clipboard'

const CopyToClipboard = ({ text, children }) => {
  const { notification } = useContext(NotificationContext)

  return (
    <>
      <RawCopyToClipboard
        text={text}
        onCopy={() => notification.success('Copied to clipboard!')}
        style={{ cursor: 'pointer' }}
      >
        {children}
      </RawCopyToClipboard>
    </>
  )
}

export default CopyToClipboard
